// @ngInject
function ArticleNewIntrastatDialogService($uibModal) {

    return {
        showDialog: showDialog
    };

    function showDialog(articleId, articleVariantId) {

        var modalDefaults = {
            backdrop: true,
            keyboard: true,
            controller: 'ArticleNewIntrastatDialogController as vm',
            templateUrl: 'main/product/articles/articleNewIntrastatDialog/articleNewIntrastatDialog.tpl.html',
            size: ''
        };

        modalDefaults.resolve = {
            articleId: articleId,
            articleVariantId: articleVariantId
        };

        return $uibModal.open(modalDefaults).result;
    }
}

// @ngInject
function ArticleNewIntrastatDialogController($scope, $uibModalInstance, articleId, articleVariantId, ProductsApiService, ToasterService, $translate, $timeout, loadSpinnerService, ResourcesService) {
    var vm = this;

    //Properties
    vm.intrastat = {};

    //Methods
    vm.saveIntrastat = saveIntrastat;
    vm.closeModal = closeModal;

    function saveIntrastat() {
        loadSpinnerService.start('mainSpinner');
        ProductsApiService.saveNewIntrastat(articleId, articleVariantId, vm.intrastat).then(function(response) {
            $uibModalInstance.close(response);
        }, function(error) {
            console.log(error);
            ToasterService.showError($translate.instant(error.message), $translate.instant('common.error'));
        }).then(function() {
            loadSpinnerService.stop('mainSpinner');
        });
    }

    function closeModal() {
        $uibModalInstance.close();
    }
}

angular
    .module('product.articles.articleNewIntrastatDialog', [])
    .service('ArticleNewIntrastatDialogService', ArticleNewIntrastatDialogService)
    .controller('ArticleNewIntrastatDialogController', ArticleNewIntrastatDialogController);
